import {
  GET_EVENT_REGISTRATION,
  GET_EVENT_REGISTRATIONS,
  SET_ALL_EVENT_REGISTRATIONS,
  SET_ALL_EVENT_REGISTRATIONS_SELECT,
  SET_ALL_EVENT_TITLE_LISTS,
  UPDATE_EVENT_REGISTRATION,
} from "../../reducerTypes";

const initialState = {
  getTitleList: [],
  getData: {},
  getList: [],
  selectData: [],
};

const eventRegistrationReducer = (state = initialState, action) => {
  switch (action.type) {
   
    case SET_ALL_EVENT_REGISTRATIONS:
      return {
        ...state,
        getList: action.payload,
      };
    case SET_ALL_EVENT_TITLE_LISTS:
      return {
        ...state,
        getTitleList: action.payload,
      };
    case GET_EVENT_REGISTRATIONS:
      return {
        ...state,
        getList: action.payload,
      };
    case SET_ALL_EVENT_REGISTRATIONS_SELECT:
      const contentData = action.payload ? action.payload : [];
      const selectData = [];
      contentData.map((data) => {
        selectData.push({
          value: data.id,
          label: `${data.title}`,
          labelEn: `${data.titleEn}`,
          price: data.price,
        });
      });
      return {
        ...state,
        selectData: selectData,
      };
    // case CREATE_EVENT:
    //     return {
    //         ...state,
    //         getData: action.payload,
    //     };
    case GET_EVENT_REGISTRATION:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_EVENT_REGISTRATION:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default eventRegistrationReducer;
